import { SIGN_UP, REQUEST } from 'constants/actions';

export default function onSignUp(values, resolve, reject) {
  return { type: SIGN_UP + REQUEST, values, resolve, reject };
}
